const isTruthyOrNumber = (value: boolean | number): boolean => {
  return !!value || typeof value === "number";
};

export default isTruthyOrNumber;
